import axios from "axios";

import { concat, pick } from "ramda";

const prefix = concat("CUSTOM_FIELDS:");

const SET_CUSTOM_FIELDS = prefix("SET_CUSTOM_FIELDS");

const FETCH_SUCCESS = prefix("FETCH_SUCCESS");
const FETCH_ERROR = prefix("FETCH_ERROR");

const INITIAL_STATE = {
  customFieldsData: [],
};

export const setCustomFields = (customFields) => ({
  type: SET_CUSTOM_FIELDS,
  payload: {
    customFields,
  },
});

export const fetchSuccess = (data) => ({
  type: FETCH_SUCCESS,
  payload: { data },
});

export const fetchError = (error) => ({
  type: FETCH_ERROR,
  payload: { error },
});

export const fetchFromApi = (campaignIds, entityId) => {
  // TODO fetch custom fields from API and dispatch it to the store
};

// Reducer
export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_SUCCESS:
      return {
        ...state,
        customFieldsData: payload.data.custom_fields || [],
      };
    case FETCH_ERROR:
      return { ...state, error: action.payload.error };
    case SET_CUSTOM_FIELDS:
      return {
        ...state,
        customFieldsData: action.payload.customFields,
      };
    default:
      return state;
  }
}
